import React from 'react';
import { Box, Typography } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';
import IdentityAvatar from './IdentityAvatar';

interface CompanyNameCellProps {
  name?: string | null;
  companyId?: string;
}

const CompanyNameCell: React.FC<CompanyNameCellProps> = ({ name, companyId }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
    <IdentityAvatar><BusinessIcon fontSize="small" /></IdentityAvatar>
    <Typography component={companyId ? 'a' : 'span'} href={companyId ? `/companies/${companyId}` : undefined} variant="body2" fontWeight="medium" noWrap sx={{ minWidth: 0, textOverflow: 'ellipsis', overflow: 'hidden', color: companyId ? 'primary.main' : 'text.primary', textDecoration: companyId ? 'none' : undefined, '&:hover': companyId ? { textDecoration: 'underline' } : undefined }}>
      {name || '—'}
    </Typography>
  </Box>
);

export default CompanyNameCell;
